import { render, staticRenderFns } from "./CustomerQuery.vue?vue&type=template&id=fb3d1de0"
import script from "./CustomerQuery.vue?vue&type=script&lang=js"
export * from "./CustomerQuery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports